<style>
/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}

@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
</style>
<template lang='pug'>
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        router-link(:to='{ name: "order-history" }') Order History
        a(v-if='selectedOrder') {{ selectedOrder.referenceNumber }}
  .row(v-if='!selectedOrder')
    .col.s12
      v-card
        v-card-title
          v-layout.justify-space-between.align-center.wrap
            v-flex.sm7
            v-flex.sm5
              v-spacer
              v-text-field.custom-search(
                v-model='search',
                append-icon='search',
                label='Search',
                single-line='',
                hide-details=''
              )
        v-card-text
          v-data-table(
            :headers='headers',
            :items='sortedOrders',
            :search='search',
            :pagination.sync='pagination'
          )
            template(slot='items', slot-scope='props')
              tr
                td
                  router-link(
                    :to='{ name: "orderHistoryByReference", params: { referenceNumber: props.item.referenceNumber } }'
                  ) {{ props.item.referenceNumber }}
                td.center-align
                  span(v-if='props.item.paymentOption === "cash"')
                    i.material-icons.hide-on-med-and-up monetization_on
                    span.hide-on-small-only Cash
                  span(v-if='props.item.paymentOption === "bank"')
                    i.material-icons.hide-on-med-and-up account_balance
                    span.hide-on-small-only Bank Deposit
                td.center-align
                  span.indigo-text(v-if='props.item.statuses["new"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"New (" + props.item.statuses["new"] + ")"'
                    ) fiber_new
                  span.orange-text(v-if='props.item.statuses["processing"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"Processing (" + props.item.statuses["processing"] + ")"'
                    ) refresh
                  span.blue-text(v-if='props.item.statuses["in-transit"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"In-transit (" + props.item.statuses["in-transit"] + ")"'
                    ) directions_transit
                  span.green-text(v-if='props.item.statuses["delivered"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"Delivered (" + props.item.statuses["delivered"] + ")"'
                    ) check_box
                  span.red-text(v-if='props.item.statuses["declined"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"Declined (" + props.item.statuses["declined"] + ")"'
                    ) do_not_disturb
                  span.red-text(v-if='props.item.statuses["cancelled"]')
                    i.material-icons.tooltipped(
                      :data-tooltip='"Cancelled (" + props.item.statuses["cancelled"] + ")"'
                    ) cancel
                td
                  span.hide-on-small-only {{ $utils.formatter.formatLongDateTime(props.item.createdAt) }}
                  span.hide-on-med-and-up {{ $utils.formatter.formatShortDateTime(props.item.createdAt) }}
            v-alert(
              slot='no-results',
              :value='true',
              color='red',
              icon='warning'
            )
              | Your search for &quot;{{ search }}&quot; found no results.

  .row(v-else)
    app-order-details(
      :order='selectedOrder',
      readOnly,
      @orderUpdated='onOrderUpdated'
    )
</template>
<script>
import AppOrderDetails from '@/components/app-order-details'
import qs from 'qs'

export default {
  meta: {
    title: 'Order History'
  },
  data () {
    return {
      orders: [],
      orderItems: [],
      selectedOrder: null,
      searchReferenceNumber: null,
      searchListener: null,
      orderRefreshInterval: null,
      showStatus: ['declined', 'cancelled', 'delivered'],
      headers: [
        { text: 'Reference Number', value: 'referenceNumber', align: 'left' },
        { text: 'Payment', value: 'paymentOption', align: 'center' },
        { text: 'Status', value: 'statuses', align: 'center' },
        { text: 'Date Ordered', value: 'createdAt', align: 'left' }
      ],
      search: '',
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  created () {
    this.getOrders()
    this.getSelectedOrder()
  },
  mounted () {
    this.$M.updateTextFields()
    this.searchReferenceNumber = this.$route.query.referenceNumber
    // this.searchListener = debounce(this.searchOrder, 1000)
    // const search = document.getElementById('search')
    // search.addEventListener('keyup', this.searchListener)
    this.orderRefreshInterval = setInterval(this.getOrders, 300000)
  },
  updated () {
    this.$M.Tooltip.init(document.querySelectorAll('.tooltipped'))
  },
  destroyed () {
    clearInterval(this.orderRefreshInterval)
  },
  watch: {
    '$route.params' () {
      this.getSelectedOrder()
    },
    '$route.query' () {
      this.getOrders()
    }
  },
  computed: {
    sortedOrders () {
      return this.orders.slice(0).sort(this.orderSortFunction)
    },
    sortedOrderItems () {
      return this.orderItems.slice(0).sort(this.orderItemSortFunction)
    },
    supplierId () {
      return this.$store.state.auth.user.supplierId
    }
  },
  methods: {
    searchOrder () {
      this.$router.push({
        name: 'order-history',
        query: { referenceNumber: this.searchReferenceNumber }
      })
    },
    orderSortFunction (orderA, orderB) {
      const fieldA = orderA['referenceNumber']
      const fieldB = orderB['referenceNumber']

      let result
        = orderA.confirmationStatus === orderB.confirmationStatus
          ? fieldA.toLowerCase() < fieldB.toLowerCase()
            ? -1
            : 1
          : orderA.confirmationStatus === 'pending'
            ? -1
            : 1
      return this.toggleSort ? result * -1 : result
    },
    orderItemSortFunction (orderItemA, orderItemB) {
      const fieldA = orderItemA['status']
      const fieldB = orderItemB['status']

      let result = 0
      result
        = fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
            ? 0
            : 1

      return this.toggleSort ? result * -1 : result
    },
    getOrders () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(`${this.$config.API_URL}/suppliers/${this.supplierId}/orders/`, {
            params: {
              deep: true,
              status: [this.showStatus],
              ...this.$route.query
            },
            paramsSerializer (params) {
              return qs.stringify(params, { arrayFormat: 'repeat' })
            },
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then((result) => {
            this.orders = result.data

            for (let i = 0; i < result.data.length; i++) {
              let statuses = []

              for (let j = 0; j < result.data[i].orderItems.length; j++) {
                if (!(result.data[i].orderItems[j].status in statuses)) {
                  statuses[result.data[i].orderItems[j].status] = 1
                } else {
                  statuses[result.data[i].orderItems[j].status]++
                }
              }
              this.orders[i].statuses = statuses
            }
          })
      })
    },
    getSelectedOrder () {
      if (!this.$route.params.referenceNumber) {
        this.selectedOrder = null
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplierId}/orders/${this.$route.params.referenceNumber}`,
            {
              params: {
                deep: true
              },
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.selectedOrder = result.data
            // let modalParams = {
            //   id: 'order-details',
            //   content: AppOrderDetails,
            //   bind: {
            //     order: this.selectedOrder
            //   },
            //   onClose: this.closeOrder
            // }
            // this.$store.dispatch('modal/open', modalParams)
          })
      })
    },
    onOrderUpdated (order) {
      if (order.id === this.selectedOrder.id) {
        this.selectedOrder = Object.assign(this.selectedOrder, order)
      }
    },
    closeOrder () {
      this.selectedOrder = null
      this.$router.back()
    }
  },
  components: {
    AppOrderDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-order-history.vue